module.exports = __webpack_public_path__ + "img/new_orleans2.403cfbcf.jpg";